/**
 * Shape of what `api.request` throws, and helpers to read it without `any`.
 * Field errors come back as `{ fields: { name: ["msg"] } }` (our views) or as
 * DRF's `{ name: ["msg"] }`; both collapse to one message per field here.
 */
export interface RequestError {
  message?: string;
  status?: number;
  data?: {
    message?: string;
    detail?: string;
    fields?: Record<string, unknown>;
    [key: string]: unknown;
  };
}

export const asRequestError = (err: unknown): RequestError =>
  err && typeof err === 'object' ? (err as RequestError) : {};

export const requestMessage = (err: unknown, fallback: string): string => {
  const e = asRequestError(err);
  return e.message && e.message !== 'Request failed' ? e.message : fallback;
};

export const requestFieldErrors = (err: unknown): Record<string, string> => {
  const fields = asRequestError(err).data?.fields;
  if (!fields || typeof fields !== 'object') return {};
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(fields)) {
    out[key] = Array.isArray(value) ? String(value[0]) : String(value);
  }
  return out;
};
